import {selectIsDcxMarket} from '@/state/selectors/auth';
import {selectLastSsoSessionApplyAt} from '@/state/selectors/media';
import type {SsoLinkEntry} from '@/state/slices/mediaSlice';
import {getState} from '@/state/store';

import {resolveSsoLinkUrlForOpen} from './resolveSsoLinkUrlForOpen';
import {isSsoCookiesFlowActive, shouldRequestIccLoginTokenListSessionInfo} from './ssoIccSessionInfoPolicy';

export const shouldRequestSessionInfo = (props: {allowSessionInfo: boolean}): boolean =>
    shouldRequestIccLoginTokenListSessionInfo({
        isDcxMarket: selectIsDcxMarket(getState!()),
        allowSessionInfo: props.allowSessionInfo,
        lastSsoSessionApplyAt: selectLastSsoSessionApplyAt(getState!()),
    });

export const isSsoCookiesFlow = (props: {openInBluefy?: boolean}): boolean =>
    isSsoCookiesFlowActive({
        isDcxMarket: selectIsDcxMarket(getState!()),
        openInBluefy: props.openInBluefy,
    });

export const resolveSsoLinkUrlForOpenFromState = (
    entry: Pick<SsoLinkEntry, 'url' | 'directUrl'>,
    openInBluefy: boolean
): string | undefined =>
    resolveSsoLinkUrlForOpen({
        entry,
        openInBluefy,
        isDcxMarket: selectIsDcxMarket(getState!()),
        lastSsoSessionApplyAt: selectLastSsoSessionApplyAt(getState!()),
    });
